/**
 * Workspace Configuration - UI
 *
 * Centralized workspace configuration driven by environment variables.
 * All workspace IDs should use this configuration to ensure consistency.
 */

// import { envConfig } from "./env";
import type { EnvConfig } from "./env";

export default function getWorkspaceConfig(config: EnvConfig) {
  // Extract workspace config from centralized env config
  const {
    defaultWorkspaceId,
    defaultConversationId,
    defaultThreadId,
    maxWorkspacesPerUser,
    workspaceNameMaxLength,
    autoCreateDefaultWorkspace,
  } = config.workspace;

  // Workspace configuration
  const workspaceConfig = {
    defaultWorkspaceId,
    defaultConversationId,
    defaultThreadId,
    maxWorkspacesPerUser,
    workspaceNameMaxLength,
    autoCreateDefaultWorkspace,

    // Validation
    isValidWorkspaceId: (id: string): boolean => {
      // Basic UUID format validation
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(id);
    },

    // Get default workspace for any context
    getDefaultWorkspaceId: (): string => defaultWorkspaceId,
    getDefaultConversationId: (): string => defaultConversationId,
    getDefaultThreadId: (): string => defaultThreadId,

    // Default workspace properties
    getDefaultWorkspaceProperties: () => ({
      id: defaultWorkspaceId,
      name: "Default Workspace",
      description: "Your default IVE workspace",
      type: "chat" as const,
      icon: "💬",
      color: "#3b82f6",
      config: {},
      createdAt: new Date(),
      updatedAt: new Date(),
      isActive: true,
    }),
  } as const;

  return workspaceConfig;
}

// Export individual values for convenience
export const DEFAULT_WORKSPACE_ID =
  import.meta.env.VITE_DEFAULT_WORKSPACE_ID ||
  "00000000-0000-4000-8000-000000000000";

// Export the workspace config function as default
export { getWorkspaceConfig as workspaceConfig };

// // Log configuration in development
// if (import.meta.env.DEV) {
//   console.log(`🏢 default workspace ID: ${DEFAULT_WORKSPACE_ID}`);
// }
